import { initializeApp, FirebaseApp } from "firebase/app";
import { 
  getMessaging, 
  getToken, 
  onMessage, 
  isSupported, // <-- IMPORTANTE: Importar a função de verificação
  Messaging 
} from "firebase/messaging";
import {
  ConfirmationResult,
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import { useInternationalVerify } from "./useInternationalVerify";

const Config = {
  apiKey: "AIzaSyAk7r2-K41mIeQI9j9v2W77XVsy8oJrEYQ",
  authDomain: "ehrrunner-74e31.firebaseapp.com",
  databaseURL: "https://ehrrunner-74e31.firebaseio.com",
  projectId: "ehrrunner-74e31",
  storageBucket: "ehrrunner-74e31.appspot.com",
  messagingSenderId: "643741161718",
  appId: "1:643741161718:web:3c79c5a0eca2f35f55f4d7",
  measurementId: "G-189CXSRTYW",
};

// --- INICIALIZAÇÃO SEGURA ---
const app = initializeApp(Config);
const auth = getAuth(app);
let messagingInstance: Messaging | null = null;
let isMessagingInitialized = false;

// Função para inicializar o Messaging de forma segura, apenas uma vez
async function initializeMessaging() {
  const supported = await isSupported();
  if (supported && !isMessagingInitialized) {
    messagingInstance = getMessaging(app);
    isMessagingInitialized = true;

    // Configura o listener de mensagens em foreground APÓS a inicialização
    onMessage(messagingInstance, (payload) => {
      console.log("Mensagem recebida em foreground:", payload);
    });
  }
  return messagingInstance;
}

// --- LÓGICA DE AUTENTICAÇÃO (sem alterações) ---
let confirmation: ConfirmationResult | null = null;
declare const window: any;

async function firebaseSendSMS(phone: string, captcha: any) {
  try {
    confirmation = await signInWithPhoneNumber(auth, phone, captcha);
  } catch (err) {
    throw err;
  }
}

async function verifyCode(code: string) {
  if (!confirmation) {
    throw new Error("Confirmation is not available.");
  }
  try {
    const result = await confirmation.confirm(code);
    return result;
  } catch (error) {
    throw error;
  }
}

async function sendVerificationCode(contact: string) {
  try {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback() {},
          "expired-callback": function () {},
        }
      );
      window.recaptchaVerifier.render();
    }
    await firebaseSendSMS(
      `+${useInternationalVerify.verifyPhoneDDI(contact.replace(/[()]/g, ""))}`,
      window.recaptchaVerifier
    );
  } catch (error) {
    console.log("error sendVerificationCode: ", error);
    throw new Error();
  }
}

// --- FUNÇÃO DE NOTIFICAÇÃO CORRIGIDA ---
async function requestNotificationPermission() {
  try {
    // 1. Tenta inicializar o messaging de forma segura
    const messaging = await initializeMessaging();

    // 2. Se a inicialização falhou (ambiente sem suporte), sai da função
    if (!messaging) {
      console.log("Firebase Messaging não é suportado neste ambiente.");
      return; // Retorna undefined, sem quebrar a aplicação
    }

    // 3. Se tem suporte, prossegue com o pedido de permissão
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BLFrhq7p-lrJNL7NaGHk2S8Y4uCmN-oG-7Npe5UlmXvpsvcEnVLugswK4N-vgUH2m66oNdQeiik-u51OMiDehOs",
      });

      if (token) {
        return token;
      } else {
        console.log("Não foi possível gerar o token de notificação.");
      }
    } else {
      console.log("Permissão para notificações foi negada pelo usuário.");
    }
  } catch (error) {
    console.error("Erro ao solicitar permissão para notificações:", error);
  }
}

export const useFirebaseService = {
  verifyCode,
  sendVerificationCode,
  requestNotificationPermission,
};